import { Instruckt } from './instruckt'
import type { FrameworkContext, InstrucktConfig, ProjectMember, SourceFrame, TestingItem, TestingItemComment, TestingItemPriority, TestingItemSeverity, TestingItemStatus } from './types'
import type { CreateTestingItemPayload, UpdateTestingItemPayload } from './api'

type VisualQAGlobal = typeof globalThis & {
  __visualQAInstance?: Instruckt
}

export { Instruckt }
export { Instruckt as VisualQA }
export type {
  CreateTestingItemPayload,
  FrameworkContext,
  InstrucktConfig,
  ProjectMember,
  SourceFrame,
  TestingItem,
  TestingItemComment,
  TestingItemPriority,
  TestingItemSeverity,
  TestingItemStatus,
  UpdateTestingItemPayload,
}

/**
 * Initialize Visual QA.
 *
 * @example
 * visualQA.init({ endpoint: '/visual-qa' })
 *
 * @example CDN
 * <script src="visual-qa.iife.js"></script>
 * <script>VisualQA.init({ endpoint: '/visual-qa' })</script>
 */
export function init(config: InstrucktConfig): Instruckt {
  const global = globalThis as VisualQAGlobal
  if (global.__visualQAInstance) return global.__visualQAInstance

  const instance = new Instruckt(config)
  const destroy = instance.destroy.bind(instance)
  instance.destroy = () => {
    destroy()
    if (global.__visualQAInstance === instance) {
      global.__visualQAInstance = undefined
    }
  }

  global.__visualQAInstance = instance
  return instance
}

export const initVisualQA = init
